import {useEffect, useState} from 'react';
import {GetLocalStorageCache, SetLocalStorageCache} from '../cache/Cache';
import {dashboardMetrics} from './dashboardMetrics';

const metricKeys = dashboardMetrics.map(metric => metric.key);

export default function useDashboardPreference(name, initialValue, allowedValues = metricKeys) {
    const key = `dashboard.${name}`;
    const [value, setValue] = useState(() => {
        try {
            const saved = GetLocalStorageCache(key);
            const valid = Array.isArray(initialValue)
                ? Array.isArray(saved) && saved.every(item => allowedValues.includes(item))
                : allowedValues.includes(saved);
            if (valid) {
                return saved;
            }
        } catch {
            // Use the default if browser storage is unavailable or contains invalid JSON.
        }
        return initialValue;
    });

    useEffect(() => {
        try {
            SetLocalStorageCache(key, value);
        } catch {
            // Keep the controls usable when browser storage is unavailable.
        }
    }, [key, value]);

    return [value, setValue];
}
